(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Footer accordion functionality
  const navHeaders = document.querySelectorAll('.footer-custom__nav-header');

  navHeaders.forEach(header => {
    header.addEventListener('click', function() {
      // Only toggle on mobile
      if (window.innerWidth >= 768) return;

      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Close all other accordions
      navHeaders.forEach(otherHeader => {
        if (otherHeader !== this) {
          otherHeader.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current accordion
      this.setAttribute('aria-expanded', !isExpanded);
    });
  });

  // Reset accordions on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth >= 768) {
        navHeaders.forEach(header => {
          header.setAttribute('aria-expanded', 'false');
        });
      }
    }, 250);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pdp-new"]) return;
  try {
    
class PdpNewQuantity extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.pdp-new__quantity-input');
    this.minusBtn = this.querySelector('.pdp-new__quantity-btn--minus');
    this.plusBtn = this.querySelector('.pdp-new__quantity-btn--plus');

    if (this.minusBtn && this.plusBtn && this.input) {
      this.minusBtn.addEventListener('click', () => this.updateQuantity(-1));
      this.plusBtn.addEventListener('click', () => this.updateQuantity(1));
    }
  }

  updateQuantity(change) {
    const currentValue = parseInt(this.input.value) || 1;
    const newValue = Math.max(1, currentValue + change);
    this.input.value = newValue;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('pdp-new-quantity')) {
  customElements.define('pdp-new-quantity', PdpNewQuantity);
}

document.addEventListener('DOMContentLoaded', function() {
  // Variant drawer functionality
  const drawerTriggers = document.querySelectorAll('[data-drawer-trigger]');
  drawerTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const drawerId = this.getAttribute('data-drawer-trigger');
      const drawer = document.getElementById(drawerId);
      if (drawer) {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  const drawerCloseButtons = document.querySelectorAll('[data-drawer-close]');
  drawerCloseButtons.forEach(button => {
    button.addEventListener('click', function() {
      const drawer = this.closest('[data-drawer]');
      if (drawer) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });

  // Variant selection in drawer
  const variantOptions = document.querySelectorAll('.pdp-new__variant-drawer-option');
  variantOptions.forEach(option => {
    option.addEventListener('click', function() {
      const drawer = this.closest('[data-drawer]');
      const optionValue = this.getAttribute('data-option-value');
      const drawerId = drawer.id;

      // Find the corresponding select element
      const selectId = drawerId.replace('variant-drawer-', 'pdp-option-');
      const select = document.getElementById(selectId);

      if (select) {
        // Update the select value
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        // Update the mobile trigger text
        const trigger = document.querySelector(`[data-drawer-trigger="${drawerId}"]`);
        if (trigger) {
          const selectedSpan = trigger.querySelector('.pdp-new__dropdown-selected');
          if (selectedSpan) {
            selectedSpan.textContent = optionValue;
          }

          // Update variant image in trigger if present
          const triggerImage = trigger.querySelector('.pdp-new__variant-thumb');
          const optionImage = this.querySelector('img');
          if (triggerImage && optionImage) {
            triggerImage.src = optionImage.src;
            triggerImage.srcset = optionImage.srcset || '';
          }
        }

        // Update drawer selected value display
        const selectedValueSpan = drawer.querySelector('.pdp-new__variant-drawer-selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = optionValue;
        }

        // Update selected state in drawer options
        const allOptions = drawer.querySelectorAll('.pdp-new__variant-drawer-option');
        allOptions.forEach(opt => opt.classList.remove('pdp-new__variant-drawer-option--selected'));
        this.classList.add('pdp-new__variant-drawer-option--selected');

        // Close drawer
        setTimeout(() => {
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }, 200);
      }
    });
  });

  // Size button selection
  const sizeButtons = document.querySelectorAll('.pdp-new__size-button');
  sizeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const optionValue = this.getAttribute('data-option-value');
      const optionName = this.getAttribute('data-option-name');
      const container = this.closest('.pdp-new__size-buttons');

      // Update the hidden input
      const hiddenInput = container.querySelector('input[type="hidden"]');
      if (hiddenInput) {
        hiddenInput.value = optionValue;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update selected state
      const allButtons = container.querySelectorAll('.pdp-new__size-button');
      allButtons.forEach(btn => btn.classList.remove('pdp-new__size-button--selected'));
      this.classList.add('pdp-new__size-button--selected');
    });
  });

  // Quantity selector functionality
  const quantityBlocks = document.querySelectorAll('.pdp-new__quantity-block');
  quantityBlocks.forEach(block => {
    const input = block.querySelector('.pdp-new__quantity-input');
    const minusBtn = block.querySelector('.pdp-new__quantity-btn--minus');
    const plusBtn = block.querySelector('.pdp-new__quantity-btn--plus');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        input.value = Math.max(1, currentValue - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  const purchaseRadios = document.querySelectorAll('.pdp-new__purchase-radio');
  purchaseRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      const form = document.getElementById(this.getAttribute('form'));
      if (form) {
        let sellingPlanInput = form.querySelector('input[name="selling_plan"]');

        if (this.value === 'subscribe' && this.dataset.sellingPlan) {
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.name = 'selling_plan';
            form.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = this.dataset.sellingPlan;
        } else if (sellingPlanInput) {
          sellingPlanInput.remove();
        }
      }
    });
  });

  // Subscription frequency dropdown handling
  const frequencySelects = document.querySelectorAll('.pdp-new__subscription-frequency-select');
  frequencySelects.forEach(select => {
    select.addEventListener('change', function() {
      const sellingPlanId = this.value;
      const wrapper = this.closest('.pdp-new__purchase-option-wrapper');

      if (wrapper && sellingPlanId) {
        // Update the radio button's data attribute
        const subscribeRadio = wrapper.querySelector('.pdp-new__purchase-radio--subscribe');
        if (subscribeRadio) {
          subscribeRadio.setAttribute('data-selling-plan', sellingPlanId);

          // If subscribe is already selected, update the form's selling_plan input
          if (subscribeRadio.checked) {
            const form = document.querySelector('[id^="product-form-pdp-new"]');
            if (form) {
              let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
              if (!sellingPlanInput) {
                sellingPlanInput = document.createElement('input');
                sellingPlanInput.type = 'hidden';
                sellingPlanInput.name = 'selling_plan';
                form.appendChild(sellingPlanInput);
              }
              sellingPlanInput.value = sellingPlanId;
            }
          }
        }
      }
    });
  });

  // Nutrition facts modal handling
  const nutritionTriggers = document.querySelectorAll('[data-nutrition-modal-trigger]');
  nutritionTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const modalId = 'nutrition-modal-' + this.getAttribute('data-nutrition-modal-trigger');
      const modal = document.getElementById(modalId);

      if (modal) {
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';

        // Trigger opacity transition after display is set
        setTimeout(() => {
          modal.classList.add('is-visible');
        }, 10);
      }
    });
  });

  const nutritionCloseButtons = document.querySelectorAll('[data-nutrition-close]');
  nutritionCloseButtons.forEach(button => {
    button.addEventListener('click', function() {
      const modal = this.closest('[data-nutrition-modal]');
      if (modal) {
        modal.classList.remove('is-visible');

        // Wait for fade out animation before hiding
        setTimeout(() => {
          modal.classList.remove('is-active');
          document.body.style.overflow = '';
        }, 300);
      }
    });
  });

  // Close modal on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.pdp-new__nutrition-modal.is-visible');
      if (activeModal) {
        activeModal.classList.remove('is-visible');
        setTimeout(() => {
          activeModal.classList.remove('is-active');
          document.body.style.overflow = '';
        }, 300);
      }
    }
  });

  // Product Recommendations Web Component
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.limit = this.dataset.limit || 4;
      this.sectionId = this.dataset.sectionId;
      this.currentIndex = 0;
      this.itemsPerPage = 1;
    }

    connectedCallback() {
      this.fetchRecommendations();
      this.setupResponsiveItemsPerPage();
      window.addEventListener('resize', () => this.setupResponsiveItemsPerPage());
    }

    setupResponsiveItemsPerPage() {
      const oldItemsPerPage = this.itemsPerPage;
      if (window.innerWidth >= 1000) {
        this.itemsPerPage = 3;
      } else {
        this.itemsPerPage = 1;
      }

      if (oldItemsPerPage !== this.itemsPerPage && this.products) {
        this.currentIndex = 0;
        this.updateCarousel();
      }
    }

    async fetchRecommendations() {
      try {
        const response = await fetch(`/recommendations/products.json?product_id=${this.productId}&limit=${this.limit}`);
        const data = await response.json();

        if (data.products && data.products.length > 0) {
          this.products = data.products;
          this.renderProducts();
          this.setupCarousel();
        } else {
          this.querySelector('[data-carousel-track]').innerHTML = '<div class="pdp-new__recommendations-loading">No recommendations available</div>';
        }
      } catch (error) {
        console.error('Error fetching recommendations:', error);
        this.querySelector('[data-carousel-track]').innerHTML = '<div class="pdp-new__recommendations-loading">Unable to load recommendations</div>';
      }
    }

    renderProducts() {
      const track = this.querySelector('[data-carousel-track]');
      const grid = document.createElement('div');
      grid.className = 'pdp-new__recommendations-grid';

      this.products.forEach(product => {
        const card = document.createElement('a');
        card.className = 'pdp-new__recommendation-card';
        card.href = product.url;

        const imageUrl = product.featured_image ? `${product.featured_image}&width=400` : '';
        const price = this.formatMoney(product.price);

        card.innerHTML = `
          <div class="pdp-new__recommendation-image-wrapper">
            ${imageUrl ? `<img class="pdp-new__recommendation-image" src="${imageUrl}" alt="${product.title}" loading="lazy">` : ''}
          </div>
          <div class="pdp-new__recommendation-info">
            <h4 class="pdp-new__recommendation-title">${product.title}</h4>
            <div class="pdp-new__recommendation-price">${price}</div>
            <span class="pdp-new__recommendation-atc">ADD TO CART</span>
          </div>
        `;

        grid.appendChild(card);
      });

      track.innerHTML = '';
      track.appendChild(grid);
    }

    setupCarousel() {
      const prevBtn = this.querySelector('[data-carousel-prev]');
      const nextBtn = this.querySelector('[data-carousel-next]');

      prevBtn.addEventListener('click', () => this.navigate('prev'));
      nextBtn.addEventListener('click', () => this.navigate('next'));

      this.renderDots();
      this.updateCarousel();
    }

    navigate(direction) {
      const maxIndex = Math.ceil(this.products.length / this.itemsPerPage) - 1;

      if (direction === 'prev' && this.currentIndex > 0) {
        this.currentIndex--;
      } else if (direction === 'next' && this.currentIndex < maxIndex) {
        this.currentIndex++;
      }

      this.updateCarousel();
    }

    updateCarousel() {
      const grid = this.querySelector('.pdp-new__recommendations-grid');
      const prevBtn = this.querySelector('[data-carousel-prev]');
      const nextBtn = this.querySelector('[data-carousel-next]');
      const maxIndex = Math.ceil(this.products.length / this.itemsPerPage) - 1;

      if (grid) {
        const offset = this.currentIndex * (100 / this.itemsPerPage);
        grid.style.transform = `translateX(-${offset}%)`;
      }

      prevBtn.disabled = this.currentIndex === 0;
      nextBtn.disabled = this.currentIndex === maxIndex;

      this.updateDots();
    }

    renderDots() {
      const dotsContainer = this.querySelector('[data-carousel-dots]');
      const totalPages = Math.ceil(this.products.length / this.itemsPerPage);

      dotsContainer.innerHTML = '';

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'pdp-new__recommendation-dot';
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        dotsContainer.appendChild(dot);
      }
    }

    updateDots() {
      const dots = this.querySelectorAll('.pdp-new__recommendation-dot');
      dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('pdp-new__recommendation-dot--active');
        } else {
          dot.classList.remove('pdp-new__recommendation-dot--active');
        }
      });
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
});

  } catch(e) { console.error(e); }
})();
})();
